import { render, staticRenderFns } from "./performance-report-table.vue?vue&type=template&id=4db8f85a"
import script from "./performance-report-table.vue?vue&type=script&lang=js"
export * from "./performance-report-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports